import { useField, useFormikContext } from 'formik'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'
import { Button } from 'blaze-ui/Button'
import Styles from './SectionsSelection.module.scss'
import { useOutline } from 'components/Wizards/MultiStepBlogPostWizard/OutlineProvider'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'
import { Input } from 'almanac-ui/TextInputField/Input'
import { NewsletterIntroValues } from '../SubjectLineSelection/Types'
import { Field } from 'components/Wizards/Field/Field'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { useSubjectLineOptions } from '../SubjectLineSelection/SubjectLineOptionsProvider'
import { Values } from './SectionsSelection'
import { useEffect } from 'react'

export const IntroductionField = (props: StepProps) => {
  const { schema, initialValues } = props
  const { isLoadingIntro, introduction: outlineIntro, generateIntro } = useOutline()
  const { values } = useFormikContext()
  const { subjectLineOptions } = useSubjectLineOptions()
  const [{ value: introduction }, , { setValue: setIntroduction }] = useField<string>('introduction')

  const fieldValues = values as Values
  const introField = Object.entries(schema.fields).find(([name, _]) => name === 'introduction')

  useEffect(() => {
    setIntroduction(outlineIntro)
  }, [outlineIntro]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {introField && (
        <Field key={introField[0]} label={introField[1].describe().meta.label} isRequired>
          {isLoadingIntro && <TextFieldLoadingState lines={3} />}
          {!isLoadingIntro && (
            <>
              <Input
                isTextarea
                scrollable={false}
                rows={4}
                name="introduction"
                value={introduction}
                onChange={(e) => setIntroduction(e.target.value)}
              />
              <div className={Styles.inputActions}>
                <Button
                  variant="secondary"
                  size="sm"
                  onPress={() => {
                    generateIntro({
                      ...initialValues,
                      generation_type: ChannelType.Newsletter,
                      title: subjectLineOptions.find((s) => s[0] === fieldValues.selected_subject_line_id)?.[1],
                    } as NewsletterIntroValues)
                  }}
                >
                  Regenerate Intro
                </Button>
              </div>
            </>
          )}
        </Field>
      )}
    </>
  )
}
